import { gql, useQuery } from '@apollo/client';
import { useFetch } from '../../../utils/useFetch';
import {
  GetQualifierQuery,
  GetQualifierQueryVariables,
} from '../../../__generated__/queries-web';

export const GET_QUALIFIER = gql`
  query GetQualifier($where: QualifierUniqueFilterInput!) {
    qualifier(where: $where) {
      id
      title
      status
      brandKey
      format
    }
  }
`;

export const useGetQualifier = (id?: string, skip?: boolean) =>
  useQuery<GetQualifierQuery, GetQualifierQueryVariables>(GET_QUALIFIER, {
    variables: { where: { id } },
    skip: !id || skip,
  });

export const useQualifierGetter = () =>
  useFetch<GetQualifierQuery, GetQualifierQueryVariables>(GET_QUALIFIER);
